import OnboardingActivity from './onboarding/OnboardingActivity';
import ReviewActivity from './review/ReviewActivity';

/**
 * Single entry point for the vocab live-session activity body (ADR 0001
 * Phase 2). The live student lobby and the teacher observer pane both mount
 * this instead of forking on `activity_type` themselves.
 *
 * This is the thin-wrapper step of Phase 2: it removes the duplicated
 * `activity_type === 'review' ? ReviewActivity : OnboardingActivity` ternary
 * from `Lobby.jsx` and `Teacher/LiveSessions/Show.jsx` and centralises the
 * choice here. The two underlying components keep their own mode-specific
 * orchestration (different submit endpoints, advance/progress models, step-back)
 * — those only merge once the backend payload/submit contract is unified in
 * Phases 3–4.
 *
 * All other props (interactive, remoteState, stepSignal, peerIntent,
 * onStateChange, onDone, flagAsTeacherFor, courseListOptions, …) pass straight
 * through to the selected component, which ignores any it doesn't use
 * (e.g. review ignores courseListOptions).
 */
export default function VocabActivity({ activity_type, ...props }) {
  const Activity = activity_type === 'review' ? ReviewActivity : OnboardingActivity;
  return <Activity activity_type={activity_type} {...props} />;
}
